<template>
  <footer class="app-footer">
    <div class="footer__inner">
      <div class="footer__aside">
        <div class="footer__links">
          <div class="footer__link">
            <a href="https://arbetsformedlingen.se/kontakt/" target="_blank">
              Kontakta oss
            </a>
          </div>
        </div>
        <div class="footer__links">
          <div class="footer__link">
            <router-link to="/om-jobskills">
              Om Jobskills
            </router-link>
          </div>
          <div class="footer__link">
            <router-link to="/arbetsgivarinformation">
              Arbetsgivarinformation
            </router-link>
          </div>
          <div class="footer__link">
            <a :href="jobskillsURL">
              Gå till Jobskills för Arbetssökande
            </a>
          </div>
          <div class="footer__link">
            <a href="https://arbetsformedlingen.se/om-webbplatsen/juridisk-information/sa-hanterar-vi-dina-personuppgifter" target="_blank">
              Så hanterar vi dina personuppgifter
            </a>
          </div>
        </div>
        <div class="footer__logo--desktop">
          <a href="https://www.arbetsformedlingen.se" target="_blank">
            <img :src="`${baseURL}static/img/af_logo_new.svg`" />
          </a>
        </div>
      </div>
      <div class="footer__content">
        <div class="footer__separator"></div>

        <div class="footer__section">
          <h2 class="footer__section-title">Om Jobskills</h2>
          <p>Jobskills är en tjänst för personer som är nya i Sverige och för arbetsgivare som vill hitta ny kompetens. Tjänsten är framtagen av Arbetsförmedlingen med syfte att underlätta etableringen på arbetsmarknaden för personer som är nya i Sverige.</p>
        </div>

        <div class="footer__separator"></div>

        <div class="footer__logo--mobile">
          <a href="https://www.arbetsformedlingen.se" target="_blank">
            <img :src="`${baseURL}static/img/af_logo_new.svg`" />
          </a>
        </div>

        <div class="footer__link footer__facebook-link" target="_blank">
          <a href="http://facebook.com/jobskills.se">Följ Jobskills på Facebook</a>

          <af-share />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Icon from '@/components/Icon'
import Button from '@/components/Button/Button'
import Share from '@/components/Share'

export default {
  name: 'AppFooter',
  components: {
    Button,
    Icon,
    'af-share': Share
  },
  data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__,
      baseURL: window.__BASE_URL__
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.app-footer {
  background-color: var(--color-stratos);
  color: var(--color-white);
  line-height: var(--line-height-body);

  @supports (display: grid) {
    grid-area: footer;
  }

  @media (--ie11) {
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }

  @supports (-ms-ime-align: auto) {
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }

  & .footer__section {
    & p {
      margin-top: 0;
    }
  }

  & .footer__section-title {
    margin-top: 0;
    margin-bottom: var(--spacing-small);
    font-weight: normal;
    font-size: 1.375em;
  }

  & .footer__terms-link {
    color: white;
  }

  & .footer__contact-icon {
    width: 20px;
    height: 20px;
    vertical-align: sub;
    margin-right: 3px;

    @media (--bp-nis-extra-small) {
      margin-right: 1px;
    }
  }

  & .footer__feedback-button {
    display: inline-block;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    padding: 8px 135px;
    background: var(--color-white);
    color: var(--color-stratos);

    &:hover {
      text-decoration: none;
      background: var(--color-alice-blue);
    }
  }

  & .footer__inner {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    padding: 60px var(--spacing-medium);
    max-width: var(--spacing-max-width-large);

    display: grid;
    grid-column-gap: var(--spacing-medium);
    grid-template-columns: 400px 1fr;

    @media (--bp-nis-extra-small) {
      grid-template-columns: 1fr;
      justify-content: center;
      width: 100%;
    }

    @media (--ie11) and (--bp-med) {
      display: block;
    }

    @supports (-ms-ime-align: auto) {
      display: -ms-grid;
      -ms-grid-columns: 300px 20px 1fr;
      -ms-grid-rows: 1fr;
    }
  }

  & .footer__aside {
    margin-right: var(--spacing-medium);
    max-width: 400px;

    @media (--ie11) {
      -ms-grid-column: 1;
    }

    @supports (-ms-ime-align: auto) {
      -ms-grid-column: 1;
    }

    & .footer__links {
      margin-bottom: var(--spacing);

      @media (--bp-nis-extra-small) {
        &:nth-child(2) {
          margin-bottom: 0;
        }
      }
    }
  }

  & .footer__facebook-link {
    @media (--bp-nis-extra-small) {
      margin-top: var(--spacing-third);
      text-align: center;
    }
  }

  & .footer__separator {
    display: none;
    border-bottom: 1px solid #333878;
    margin: var(--spacing) calc(-1 * var(--spacing-medium));

    @media (--bp-nis-extra-small) {
      display: block;
    }
  }

  & .footer__logo--mobile {
    display: none;

    @media (--bp-nis-extra-small) {
      display: block;
      text-align: center;
    }
  }

  & .footer__logo--desktop {
    margin-top: var(--spacing-large);

    @media (--bp-nis-extra-small) {
      display: none;
    }
  }

  & .footer__link {
    margin-bottom: 0.5em;

    & a {
      color: var(--color-white);

      &:focus {
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  & .footer__content {
    color: var(--color-white);
    margin: 0;

    @media (--ie11) {
      -ms-grid-column: 3;
    }

    @supports (-ms-ime-align: auto) {
      -ms-grid-column: 3;
    }

    & p:first-of-type {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/AppFooter.vue